import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { SERVER_URL } from "../../api/url";
import Logo from "../../assets/images/logos/edu-logo.png";
import eeaio from "../../assets/images/eeaio.png";
import { set } from "lodash";
import useStore from "../../store/information";

const FooterTwo = (props) => {
  const { footerClass, ctaSubtitle, ctaTitle, ctaBtn } = props;

  const [data, setData] = useState({});
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading,setloading]=useState(false);
  const [formError,setformError]=useState("")
  const { totalInfo } = useStore();
  const [loginData,setloginData]=useState("")
  const [name,setName]=useState("")

    useEffect(() => {
      if (totalInfo) {
        const ph1 = localStorage.getItem('ph1');
     console.log(totalInfo,ph1)
        const email = localStorage.getItem('email');
        setData({
          phoneNumber: totalInfo.phoneNumber || ph1,
          email: totalInfo.email || email ,
        });
      }
    }, [totalInfo]);

   



  const handleSubscribeClick = async () => {
    if (showEmailForm) {
      if (!email) {
        setformError("Email is required");
        return;
      }
    

     

      try {
    
   const response2 = await axios.post(
          `${SERVER_URL}/about/click_to_subscribe`,
          { email },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
             
            },
            timeout: 5000, // Timeout for the second request (5 seconds)
          }
        );
        setformError("");
        setError("");
        setName("")
        setPassword("")
        setEmail("")
        setShowEmailForm(false);
        setMessage(response2?.data?.data);
  
    } catch (err) {
      console.error('Error submitting form:', err.response);
      setError('There was an error submitting the form.');
      setMessage("")
    } finally {
        setloading(false);
      }
    } else {
      setShowEmailForm(true);
      setMessage("");
      setError("");
      setformError("");
    }
  };



  return (
    <footer
      id="react-footer"
      className={footerClass ? footerClass : "react-footer react-footer-two pt---120"}
    >
      <div className="footer-top">
        <div className="container">
          <div
            className="footer-top-cta wow animate__fadeInUp"
            data-wow-duration="0.6s"
          >
            <div className="row">
              <div className="col-lg-7">
                <h4>
                  {ctaSubtitle
                    ? ctaSubtitle
                    : "စာလေ့လာဖို့ မမေ့ရလေအောင် subscribe လုပ်ထားပါ"}
                </h4>
                <h3>
                  {ctaTitle
                    ? ctaTitle
                    : "Subscribe to our Newsletter for Newest Course Updates"}
                </h3>
              </div>
              <div className="col-lg-5 text-right">
                <button className="btn" onClick={handleSubscribeClick}>
                  <Link to="">
                    {ctaBtn ? ctaBtn : "Subscribe!"}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-arrow-right"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </Link>
                </button>
              </div>

              {/* Display success/error messages */}
              {message && (
                <div className="alert alert-info">
                  {message}
                </div>
              )}
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}

              {/* Show the modal form if showEmailForm is true */}
              {showEmailForm && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <div className="email-subscribe-form">
                      <form >
                        {/* Email input field */}
                         
                        <input
                          type="email"
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter your email address"
                          required
                          className="form-control p-3 rounded"
                        />

                      

                      {
                        formError && (
                          <div style={{ color: 'red', fontSize: '12px', textTransform: 'lowercase',textAlign:"start" }}>
                            *{formError}
                          </div>
                        )
                      }

                       
                      </form>
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button type="submit" className="add-modal-btn" onClick={handleSubscribeClick}>
              {loading ? "loading...":"Subscribe"}
            </button>
            <button onClick={() => {
               setformError("")
              setShowEmailForm(false)
              }} className="close-modal-btn">
              Close
            </button>
          </div>

                     
                    
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container">
            <div className="row">
              <div className="col-lg-3 md-mb-30">
                <div className="footer-widget footer-widget-1">
                  <div className="footer-logo white">
                    <Link to="/" className="logo-text">
                      <img src={Logo} alt="Footer Logo" />
                    </Link>
                  </div>
                  <h5 className="footer-subtitle">
                  Practice a little every day to see big results! <br />
                  Don’t wait to start your French learning journey! Download Your French Teachers App now and unlock a world of opportunities.
                    Bonjour, French fluency!
                  </h5>
                  <ul className="footer-address">
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-phone"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>
                      <a href={`#`}>(+95){data.phoneNumber}</a>
                    </li>
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-mail"
                      >
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      <a href="#">
                      {data.email || 'info@yourfrenchteachers.com'}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 md-mb-30">
                <div className="footer-widget footer-widget-2">
                  <h3 className="footer-title">About Us</h3>
                  <div className="footer-menu">
                    <ul>
                      <li>
                        <Link to="/about">About</Link>
                      </li>
                      <li>
                        <Link to="/instructor">Instructor</Link>
                      </li>
                      <li>
                        <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                      <li>
                        <Link to="/quotation">Quotation</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 md-mb-30">
                <div className="footer-widget footer-widget-3">
                  <h3 className="footer-title">Courses</h3>
                  <div className="footer-menu">
                    <ul>
                      <li>
                        <Link to="/adult">Adult</Link>
                      </li>
                      <li>
                        <Link to="/kid">Kid</Link>
                      </li>
                      <li>
                        <Link to="/native">Native</Link>
                      </li>
                      <li>
                        <Link to="/books">Books</Link>
                      </li>
                      <li>
                        <Link to="/level-test">Level Test</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-3">
                <div className="footer-widget footer-widget-4">
                  <h3 className="footer-title">Newsletter</h3>
                  <div className="footer3__form">
                    <p>
                      Get the latest Your French Teachers news <br />
                      delivered to you inbox
                    </p>
                    <form action="#">
                      <input
                        type="email"
                        required
                        placeholder="Enter your email"
                      />
                      <button className="footer3__form-1">
                        <i className="arrow_right"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-3">
                <div className="footer-widget footer-widget-4">
                  <h3 className="footer-title">Download Our App</h3>
                  <div
                    className="slider-btn wow animate__fadeInUp"
                    data-wow-duration="1.2s"
                  >
                    <a
                     href="https://apps.apple.com/us/app/your-french-teachers/id6742703203"  target="_blank"
                      className="btn btn-dark btn-lg px-3 py-2 me-3 me-sm-3 me-lg-4 mb-3"
                    >
                      <img
                        src="./appstore-light.svg"
                        className="light-mode-img"
                        width={124}
                        alt="App Store"
                      />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.khinezin.yftapp"  target="_blank" className="btn btn-dark btn-lg px-3 py-2 mb-3">
                      <img
                        src="./googleplay-light.svg"
                        className="light-mode-img"
                        width={139}
                        alt="Google Play"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <div className="copyright">
          <div className="container">
            <div className="react-copy-left">
              © {new Date().getFullYear()} <Link to="/">Your French Teachers.</Link> All Rights Reserved.Build by <Link to="https://ojodigitalmarketing.com" className="eeaio-text">OJO</Link>
            </div>
            <Link to="https://ojodigitalmarketing.com/" className="eeaio-logo">
                      <img src={eeaio} alt="Footer Logo" />
              </Link>
            {/* <div className="react-copy-right">
              <ul className="social-links">
                <li className="follow">Follow us</li>
                <li>
                  <Link to="#">
                    <span aria-hidden="true" className="social_facebook"></span>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <span aria-hidden="true" className="social_twitter"></span>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <span aria-hidden="true" className="social_linkedin"></span>
                  </Link>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
    </footer>
  );
};

export default FooterTwo;
